import Vue from 'vue';

import ControlProduccion from './control_produccion/views/ControlProduccion';
import MachineProductionControl  from  './machine_production_control/views/MachineProductionControl';
import Monitorization  from  './monitorization/views/Monitorization';
import OrderReferenceView  from  './order_reference_view/views/OrderReferenceView';
import Dataloggers  from  './dataloggers/views/DataloggersView';
import ProductionLineIndex  from  './production_line/views/ProductionLineIndex';
import ProductionLineEdit from  './production_line/views/ProductionLineEdit';
import ProductionLineCreate from  './production_line/views/ProductionLineCreate';
import MachineSelector  from  './machine_selector/views/MachineSelector';
import UserIndex  from  './user/views/UserIndex';
import AboutComponent from './common/about.vue';
import HeaderView from './header/views/HeaderView.vue';
import CalendarIndex from './calendar/views/CalendarIndex.vue';
import ShiftsTemplateIndex from './calendar/shifts_template/views/ShiftsTemplateIndex.vue';
import ShiftsTemplateEdit from './calendar/shifts_template/views/ShiftsTemplateEdit.vue';
import StationEdit from './station/views/StationEdit.vue';
import PermissionsIndex from './settings/views/PermissionsIndex.vue';
import HomeView from './home/views/HomeView.vue';
import RolesIndex from './settings/views/RolesIndex.vue';
import OperatorIndex from './operator/views/OperatorIndex.vue';
import OperatorTitleIndex from './operator-title/views/OperatorTitleIndex.vue';
import OrderReferenceIndex from './order_reference/views/OrderReferenceIndex.vue';
import SuperadminConfigurations from './superadmin/views/SuperadminConfigurations.vue';
import MachineEdit from './machine/views/MachineEdit.vue';
import ConfectionProductionReporting from './confection_production_reporting/views/ConfectionProductionReporting.vue';
import AdminConfigurations from './admin/views/AdminConfigurations.vue';
import ReferenceIndex from './reference/views/ReferenceIndex.vue';
import MachineIndex from './machine/views/MachineIndex.vue';

const components = [
    ControlProduccion,
    MachineProductionControl,
    Monitorization,
    OrderReferenceView,
    Dataloggers,
    ProductionLineIndex,
    ProductionLineEdit,
    ProductionLineCreate,
    MachineSelector,
    UserIndex,
    AboutComponent,
    HeaderView,
    CalendarIndex,
    ShiftsTemplateIndex,
    ShiftsTemplateEdit,
    StationEdit,
    PermissionsIndex,
    HomeView,
    RolesIndex,
    OperatorIndex,
    OperatorTitleIndex,
    OrderReferenceIndex,
    SuperadminConfigurations,
    MachineEdit,
    ConfectionProductionReporting,
    AdminConfigurations,
    ReferenceIndex,
    MachineIndex,
];

components.forEach(component => {
    Vue.component(component.name, component);
});